
import PIXI from '../GameEngine/pixi.js';
export default class PlayerScoreBoardMini extends PIXI.Sprite {
    constructor(name,avatar,color) {
        super();
        this.score = 0;
        this.name = name || "Player";
        this.avatar = avatar ||"Avatar";
        this.color = color|| 0x479ACE;// or 0x479ACE or 0xC03500

        var style = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 50,
            fill: '#FFFFFF',
            wordWrap: true,
            wordWrapWidth: 800,
            align: 'center'
        });

        var background = new PIXI.Graphics();
        background.beginFill(0x000000);
        //background.lineStyle(2, 0xFFFF00, 1);
        background.drawRect(0, 0, 250, 50);
        //background.drawRoundedRect(0, 0, 200, 100, 10);
        //background.alpha = 0.8;
        this.addChild(background);

        var backgroundAvatar = new PIXI.Graphics();
        backgroundAvatar.beginFill(0x999999);
        //background.lineStyle(0, 0xFFFFFF, 1);
        backgroundAvatar.drawRect(0, 0, 50, 50);
        //graphics.drawRoundedRect(0, 0, 200, 100, 10);
       // background.alpha = 0.5;
        this.addChild(backgroundAvatar);


        //Avatar 
        var Avatar = new PIXI.Sprite(PIXI.Loader.shared.resources[this.avatar].texture);
        Avatar.x = 0;
        Avatar.y = 0;
        Avatar.width = 50;
        Avatar.height = 50;
        this.addChild(Avatar);


        var scoreBox = new PIXI.Graphics();
        scoreBox.beginFill(this.color);
        scoreBox.drawRect(200, 0, 50, 50);
        //scoreBox.alpha = 0.5;
        this.addChild(scoreBox);

        //textPlayer1Points
        this.textName = new PIXI.Text(this.name, style);
        this.textName.x = 70;
        this.textName.y = 10;
        this.textName.scale.set(0.5);
        this.addChild(this.textName);

        //textPlayer2Points
        this.textPoints = new PIXI.Text('34', style);
        this.textPoints.x = 226;
        this.textPoints.y = 10;
        this.textPoints.scale.set(0.5);
        this.textPoints.anchor.set(0.5, 0);
        this.addChild(this.textPoints);


    }
    updateScore(score) {
        if (score) this.score = score;
        this.textPoints.text = score || 0;
    }

}